import { AnimatePresence, motion } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function Lightbox({ src, onClose }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <button onClick={onClose} aria-label="Close"
            className="absolute top-4 right-4 rounded-full bg-white/10 text-white p-2 hover:bg-white/20">
            <XMarkIcon className="h-6 w-6" />
          </button>
          <motion.img
            src={src} alt="proof of work"
            className="max-h-[85vh] max-w-full rounded-xl shadow-2xl"
            initial={{ scale: 0.92 }} animate={{ scale: 1 }} exit={{ scale: 0.92 }}
            onClick={(e) => e.stopPropagation()}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
